export const {
  REACT_APP_API_URL: API_URL = 'localhost:5000',
} = { ...process.env, ...window['env'] }
